import {Typography} from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import {ISavedSearchConcept} from 'app/models/saved_search'
import {DiscoveryRequestConcept} from 'app/modules/discovery/core/_models'
import React from 'react'
import {emInstanceOf} from 'utilities/extensionMethods'
import {ConceptChip} from './ConceptChip'
import {SmallConceptChip} from './SmallConceptChip'

export enum conceptType {
  toolbar = 'toolbar',
  result = 'result',
  detail = 'detail',
}

type Props = {
  concepts: ISavedSearchConcept[] | DiscoveryRequestConcept[]
  canAdd?: boolean
  stackVertical?: boolean
  currScrollPosition?: number
  retval?: string
  size?: 'small' | 'regular'
}

export default function ConceptsList({
  concepts,
  canAdd,
  stackVertical,
  currScrollPosition,
  retval,
  size,
}: Props): React.ReactElement {
  let cons: ISavedSearchConcept[] = []
  if (emInstanceOf<DiscoveryRequestConcept>(concepts.length ? concepts[0] : [], 'graph_id')) {
    const x = concepts as unknown as DiscoveryRequestConcept[]
    x?.map((drc) => {
      cons.push({
        id: drc.graph_id,
        name: drc.getName(),
        __weight: drc.weight ?? 1,
        __lock: 'include',
      })
    }) ?? []
  } else {
    cons = concepts as unknown as ISavedSearchConcept[]
  }

  // Sometimes we get the same concept more than once. Pick the highest-weighted one.
  const selectedCons: Record<string, ISavedSearchConcept> = {}
  for (const concept of cons) {
    if (!concept.id) {
      continue
    }
    const existing = selectedCons[concept.id]
    if (existing === undefined || existing.__weight < concept.__weight) {
      selectedCons[concept.id] = concept
    }
  }
  const uniqueCons: ISavedSearchConcept[] = Object.values(selectedCons)

  return (
    <>
      <Typography variant='caption'>
        <Stack direction={stackVertical ? 'column' : 'row'} spacing={1} flexWrap={'wrap'}>
          {uniqueCons.map((concept, idx) => {
            const chipLink = !retval
              ? `/concepts/detail?externalId=${concept.id}&scrollPosition=${currScrollPosition}`
              : `/concepts/detail?externalId=${concept.id}&scrollPosition=${currScrollPosition}&retval=${retval}`
            return (
              <Box display={'inline-flex'} key={idx}>
                {size && size === 'small' ? (
                  <SmallConceptChip key={idx} concept={concept} link={chipLink} />
                ) : (
                  <ConceptChip key={idx} concept={concept} link={chipLink} />
                )}
              </Box>
            )
          })}
        </Stack>
      </Typography>
    </>
  )
}
